/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelImageAutoComplete = new Class({
  Extends: QuriobotElement,
  template: function (displayType) {
    var base = {
      list:
        '<div class="panel--wrapper panel--autocomplete no--options" id="options__{{ eid }}">' +
        '   <div class="panel--main">' +
        '       <ul role="listbox" id="page__{{ eid }}">' +
        '       </ul>' +
        '   </div>' +
        '</div>' +
        '<div class="input--wrapper input--autocomplete isLoading" family="{{ key }}" id="{{ eid }}">' +
        '   <div class="input--inner">' +
        '       <div aria-label={{ title }} role="combobox" aria-expanded="false" aria-owns="page__{{ eid }}" class="input--content">' +
        '           <input autocomplete="off" aria-autocomplete="list" aria-controls="page__{{ eid }}" type="text" placeholder="{{ placeholder }}" class="data--wrapper" id="autoCompleteInput" />' +
        '       </div>' +
        '       <button type="button" type="submit" class="input--button"></button>' +
        '   </div>' +
        '</div>',

      tiles:
        '<div class="panel--wrapper panel--anchor isLoading" family="{{ key }}" id="{{ eid }}">' +
        '    <div class="panel--main">' +
        '        {{ title }}' +
        '        <div class="arrow"></div>' +
        '        <div class="redo--x"></div>' +
        '    </div>' +
        '</div>',
    }

    var options =
      '<div class="page--search">' +
      '    <div class="page--header">' +
      '        <h1>{{ title }}</h1>' +
      '        <div class="page--form">' +
      '            <input autocomplete="off" type="search" name="search" placeholder="{{ placeholder }}"/>' +
      '            <button class="search">' +
      '                <span class="icon__search"></span>' +
      '                <span class="page--buttonText">' +
      '                    {{ go_button_text }}' +
      '                </span>' +
      '            </button>' +
      '        </div>' +
      '    </div>' +
      '    <div class="page--body">' +
      '        <div class="page--options">' +
      '            <ul id="page__{{ eid }}">' +
      '                {% options %}' +
      '            </ul>' +
      '        </div>' +
      '    </div>' +
      '</div>'

    var location =
      '<li role="option" autocomplete-id="{{ id }}" class="option google--location">' +
      '    <span class="autocomplete--text">{{ description }}</span>' +
      '</li>'

    var empty = '<li class="empty--result"><span>{{ notFoundError }}</span></li>'

    return {
      base: base[displayType],
      options: options,
      empty: empty,
      location: location,
    }
  },
  populate: function (optionsHTML) {
    var base = this.template(this.displayType).base

    Object.each(this.data, function (val, key) {
      base = base.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), val)
    })

    this.data.go_button_text = this.data.meta.go_button_text || 'Search'
    var options = this.template(this.displayType).options
    Object.each(
      this.data,
      function (val, key) {
        options = options.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), val)
      }.bind(this)
    )

    options = options.replace(/\{\%\s*options\s*\%\}/g, optionsHTML)

    return {
      anchor: base,
      options: options,
    }
  },
  populateOption: function (obj) {
    var itemHTML =
      '<li data-option-id="{{ id }}" data-url="{{ url }}" data-url-target="{{ urlTarget }}" id="{{ id }}" class="option"><div class="product--wrapper"><div class="check--wrapper"></div><div class="product--image"><img src="{{ image }}"/></div><div class="product--description"><h1>{{ text }}</h1>{{ description }}</div></div></li>'

    if (obj) {
      Object.each(
        obj,
        function (val, key) {
          itemHTML = itemHTML.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), val)
        }.bind(this)
      )
    } else {
      itemHTML =
        '<li><div class="product--wrapper"><div class="product--description empty" style="text-align:center;">We couldn\'t find the product you where looking for..</div></div></li>'
    }

    return itemHTML
  },
  populateOptions: function (options, append) {
    var optionsHTML = ''
    var _e = this.template().empty
    this.quriobot.getError(
      this.data,
      'not_found',
      null,
      function (notFoundError) {
        var data = Object.merge(this.data, { notFoundError: notFoundError || 'Your search has no results' })

        Object.each(
          data,
          function (val, key) {
            _e = _e.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), val)
          }.bind(this)
        )

        if (!options || !options.length) {
          optionsHTML = _e
        } else {
          options.each(
            function (obj) {
              optionsHTML += this.populateOption(obj) + '\n'
            }.bind(this)
          )
        }
        this.addToDom(optionsHTML, append)
      }.bind(this)
    )
  },
  displayType: 'tiles',
  paginationCurrent: 0,
  paginationMax: null,
  isUpdating: false,
  limit: 10,
  autoCompleteInput: null,
  makeApiCall: function (newSearch) {
    // fetch search params.
    if (!newSearch) {
      if (this.isUpdating) {
        return
      } else {
        this.isUpdating = true
      }
    } else {
      this.isUpdating = true
    }

    var _allow = true
    if (newSearch) {
      this.paginationCurrent = 0
    }

    if (this.paginationMax && this.paginationCurrent >= this.paginationMax) {
      _allow = false
      return
    }

    if (this.data.meta && this.data.meta.getOptionsScript) {
      this.getOptionsCallback(
        this.data.meta.getOptionsScript,
        { input: this.autoCompleteInput, limit: this.limit, offset: this.paginationCurrent },
        function (options) {
          if (options && options.items) {
            options.items = options.items.map(function (item) {
              return {
                id: item.value,
                text: item.label || '',
                image: item.image || '',
                description: item.description || '',
                url: item.url || '',
                urlTarget: item.url || ''
              }
            })
            this.handleApiCall(options)
          } else {
            this.addToDom('error', false)
          }
        }.bind(this)
      )
    } else {
      var result = quriobot.search(this.data.options, this.autoCompleteInput, this.data.meta && this.data.meta.searchThreshold).map(
        function (item) {
          return {
            id: item.id,
            text: item.text || '',
            image: item.image || '',
            description: item.comment || '',
            url: item.url || '',
            urlTarget: item.urlTarget || ''
          }
        }.bind(this)
      )

      result = result.filter(Boolean)
      var items = result.slice(this.paginationCurrent, this.paginationCurrent + this.limit)
      this.handleApiCall({ items: items, count: result.length })
    }
  },
  handleApiCall: function (resultData) {
    this.paginationCurrent = this.paginationCurrent + this.limit

    var list = resultData.items
    var max = resultData.count

    if (!this.paginationMax) {
      this.paginationMax = max
      this.populateOptions(list)
    } else {
      this.populateOptions(list, true)
    }
  },
  makeApiCall_single: function (id, singleCallback) {
    var _p = typeOf(this.api.putPagination) == 'object' ? this.api.putPagination : false
    var _d = Object.clone(this.api.putData)
    _d[this.api.getData.inputs[0]] = id
    _d[_p.offsetKey] = 0
    _d[_p.lengthKey] = 1

    if (id) {
      new Request({
        url: this.api.putUrl,
        method: this.api.putMethod,
        type: this.api.putExpect,
        data: _d,
        onComplete: function (result) {
          var resultDataObj = this.api.putExpect == 'JSON' ? JSON.parse(result) : result

          var item = resultDataObj[this.api.getData.listKey][0]
          var htmlResult = new Element('div', {
            html: this.populateOption(item),
          })

          singleCallback(htmlResult)
        }.bind(this),
        onError: function (err) {}.bind(this),
      }).send()
    }
  },
  emptyOptions: function () {
    this.page_options.set('html', '')
  },
  addToDom: function (resultsData, update) {
    this.isUpdating = false
    if (!resultsData) {
      this.makeApiCall()
      return
    }
    if (!update) {
      var htmlContent = this.populate(resultsData)
      this.parent_after.appendHTML(htmlContent.anchor, 'before')
      this.foldOut(htmlContent.options, true)
      this.page_options = $('page__' + this.data.eid)
    } else {
      this.page_options.appendHTML(resultsData)
      this.attach_options()
      return
    }
    this.in()
  },
  show_autoCompleteOptions: function () {
    this.auto_options.removeClass('no--options')
    $$('.input--content').set('aria-expanded', true)
  },
  hide_autoCompleteOptions: function () {
    this.auto_options.addClass('no--options')
    $$('.input--content').set('aria-expanded', false)
  },
  attach: function () {
    var _contentWrapper = this.foldOutHtml().getElements('.page--options')[0]
    if (!_contentWrapper) {
      return
    }

    _contentWrapper.addEvents({
      scroll: function (e) {
        var distScrolled = _contentWrapper.getScroll().y,
          distToTop = _contentWrapper.getScrollSize().y - _contentWrapper.getSize().y

        if (distScrolled + 30 >= distToTop) {
          this.makeApiCall()
        }
      }.bind(this),
    })

    var _searchWrapper = this.foldOutHtml().getElements('.page--form')[0]
    var _searchInput = _searchWrapper.getElements('input')[0]
    var _searchButton = _searchWrapper.getElements('button')[0]

    // remove header from foldout
    this.foldOutContainer().addClass('fold-out_type_no-header')

    var _searchTimer = null
    _searchInput.addEvents({
      keyup: function (e) {
        clearTimeout(_searchTimer)
        if (e.key == 'enter') {
          this.autoCompleteInput = _searchInput.get('value')
          this.emptyOptions()
          this.makeApiCall(true)
        } else {
          _searchTimer = setTimeout(
            function () {
              this.autoCompleteInput = _searchInput.get('value')
              this.emptyOptions()
              this.makeApiCall(true)
            }.bind(this),
            500
          )
        }
      }.bind(this),
      click: function () {
        _searchTimer = setTimeout(
          function () {
            this.autoCompleteInput = _searchInput.get('value')
            this.emptyOptions()
            this.makeApiCall(true)
          }.bind(this),
          500
        )
      }.bind(this),
    })

    _searchButton.addEvents({
      click: function (e) {
        clearTimeout(_searchTimer)
        this.autoCompleteInput = _searchInput.get('value')
        this.emptyOptions()
        this.makeApiCall(true)
      }.bind(this),
    })

    var _redo = this.element.getElements('.redo--x')[0]
    _redo.addEvents({
      click: function (e) {
        if (this.foldOutOpen) {
          return
        }
        if (e) {
          e.preventDefault()
        }
        this.element.removeClass('isAnswered')
        this.foldOutContainer().addClass('fold-out_type_no-header')
        this.redoCallback(this.data, this.element)
        this.foldOut(false, true)
      }.bind(this),
    })
    this.attach_options()
  },
  attach_options: function () {
    if (this.page_options) {
      var options = this.page_options.getElements('.option')
    }
    var optionClicked = false
    options.each(
      function (obj, i) {
        obj.removeEvents()
        var url = obj.get('data-url')
        if (url) {
          this.quriobot.populateURL(
            url,
            function (url) {
              obj.set('data-url', url)
            }.bind(this)
          )
        }
        obj.addEvents({
          click: function (e) {
            e.preventDefault()

            if (!optionClicked) {
              optionClicked = true
              setTimeout(function () {
                optionClicked = false
              }, 500)
              this.selectedOption = obj.clone()
              var url = this.selectedOption.get('data-url')
              var urlTarget = this.selectedOption.get('data-url-target')
              this.openURL(url, urlTarget)
              this.after()
            } else {
              return
            }
          }.bind(this),
        })
      }.bind(this)
    )
  },
  handlePrefilled: function (savedData) {
    if (!savedData) {
      if (!this.data.savedValue.render) {
        var answerData = {
          answer: {
            value: this.data.savedValue.value,
            content: this.data.savedValue.value,
            render: false,
          },
        }
        this.handlePrefilled(answerData)
        return
      } else {
        this.makeApiCall_single(this.data.savedValue.value, this.handlePrefilled.bind(this))
        return
      }
    } else {
      if (this.data.savedValue.render) {
        this.selectedOption = savedData.getElements('li')[0]
        var answerData = {
          answer: {
            value: this.data.savedValue.value,
            content: this.selectedOption.get('html'),
            render: 'product product--preset',
          },
        }
      } else {
        var answerData = savedData
      }

      this.answerCallback(this.data, answerData, true)
    }
  },
  after: function () {
    this.foldOutClose()
    this.element.addClass('isAnswered')
    var content = this.selectedOption.getElements('.product--description h1').map(function (item) {
      return item.get('text').trim()
    })
    var answerData = {
      answer: {
        value: [this.selectedOption.get('data-option-id')],
        content: content,
        render: 'product',
      },
    }
    this.answerCallback(this.data, answerData)
  }
})
